export default "__VITE_ASSET__Xcbwc19I__"